module.exports = "/assets/3e123eab630cbb2eb5d086248ca3862c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IB.png
// module id = 2593
// module chunks = 0